export default {
  "account": {
    "curatedCollections": "Bailiúcháin Coimeádaithe",
    "curatedCollectionsInfo": "Faigh thíos na bailiúcháin go léir a choinnigh tú",
    "editProfile": "Cuir do phróifíl in eagar",
    "likes": "Toghanna",
    "linkAccount": "Mo Chuntas",
    "linkLogin": "Logáil isteach",
    "linkLoginJoin": "Logáil Isteach",
    "linkLogout": "Logáil amach",
    "myProfile": "Mo phróifíl",
    "notifications": {
      "loggedIn": "Tá tú logáilte isteach anois. Fáilte!",
      "loggedOut": "Tá tú logáilte amach anois.",
      "noCollections": {
        "curated": "Níor choimeád tú aon bhailiúcháin go fóill",
        "private": "Níor chruthaigh tú aon ghailearaithe príobháideacha fós",
        "public": "Níor chruthaigh tú aon ghailearaithe poiblí fós"
      },
      "noLikedItems": "Níor thaitin leat aon earraí fós"
    },
    "privateCollections": "Gailearaithe Príobháideacha",
    "profile": "Mo Thoghanna & Gailearaithe",
    "profileSettings": "Socruithe próifíle",
    "publicCollections": "Gailearaithe Poiblí",
    "settings": "Socruithe",
    "title": "Mo chuntas"
  },
  "actions": {
    "accept": "Glac leis",
    "cancel": "Cealaigh",
    "close": "dún",
    "continue": "Lean ar aghaidh",
    "download": "Íoslódáil",
    "edit": "Cuir in eagar",
    "feedback": "Aiseolas",
    "goBack": "Dul siar",
    "goHome": "Téigh go dtí an leathanach baile",
    "learnMore": "Foghlaim níos mó",
    "like": "Is maith liom",
    "move": "Bog",
    "next": "Ar Aghaidh",
    "pin": "Bioráin",
    "preview": "Réamhamharc",
    "previous": "Roimhe Seo",
    "providedBy": "Arna sholáthar ag {provider}",
    "reject": "Diúltaigh",
    "save": "Sábháil",
    "send": "Seol",
    "share": "Roinn",
    "shareOn": "Roinn ar {social}",
    "skip": "Scipeáil",
    "viewAt": "Féach ar ag {link}",
    "viewDocument": "Breathnaigh ar dhoiciméad"
  },
  "attribution": {
    "country": "Tír:",
    "creator": "Cruthaitheoir:",
    "date": "Dáta:",
    "institution": "Institiúid:",
    "title": "Teideal:"
  },
  "automatedCardGroup": {
    "item": "Míreanna le déanaí",
    "organisation": "Eagraíochtaí",
    "place": "Áiteanna",
    "time": "Na hAois réadmhaoin",
    "topic": "Topaicí réadmhaoine"
  },
  "blog": {
    "author": "Údar",
    "authors": "Údair",
    "blog": "Blag",
    "by": "le",
    "categories": "Catagóirí",
    "category": "Catagóir",
    "posts": "Poist bhlag",
    "published": "Foilsithe {date}",
    "relatedPosts": "Postálacha gaolmhara"
  },
  "cardLabels": {
    "organisation": "Eagraíocht",
    "person": "Duine",
    "place": "Áit",
    "theme": "Téama",
    "time": "Haois",
    "topic": "Ábhar"
  },
  "clearAllFilters": "glan gach scagaire",
  "collections": {
    "actions": {
      "edit": "Cuir Bailiúchán in Eagar",
      "update": "Bailiúchán Nuashonraithe"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "dearthóirí",
          "name": "Dearthóir | Dearthóirí",
          "select": "Roghnaigh dearthóirí"
        },
        "proxy_dc_format": {
          "moreName": "teicnící",
          "name": "Teicníc | Teicnící",
          "select": "Roghnaigh teicnící"
        },
        "proxy_dc_type": {
          "moreName": "cineálacha míreanna",
          "name": "Cineál míre | Cineálacha míreanna",
          "select": "Roghnaigh cineálacha míreanna"
        },
        "proxy_dcterms_medium": {
          "moreName": "ábhair",
          "name": "Ábhar | Ábhair",
          "select": "Roghnaigh ábhair"
        }
      }
    },
    "form": {
      "description": "Cur síos"
    },
    "notifications": {
      "update": "Rinneadh nuashonrú ar an mbailiúchán"
    }
  },
  "collectionsYouMightLike": "Bailiúcháin b’fhéidir gur mhaith leat",
  "colourSwatch": "Swatch dath",
  "contentYouMightLike": "Ábhar b’fhéidir gur mhaith leat",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Tuilleadh eolais",
      "about": "Maidir le Europeana",
      "forDevelopers": "Faoi chomhair forbróirí",
      "help": "Cabhair",
      "meetUs": "Cuir aithne ar an bhfoireann",
      "provide": "Bí I do sholátharí sonraí",
      "subscribe": "Liostáil lenár Nuachtlitir",
      "terms": "Téarmaí úsáide agus Beartas príobháideachta"
    },
    "headerNavigation": {
      "Collections": "Bailiúcháin",
      "explore": "Taiscéal",
      "teachers": "Múinteoirí"
    }
  },
  "curatedAutomatically": "Coimeádaithe go huathoibríoch ag Europeana",
  "dateFilter": {
    "endDate": "Dáta deiridh",
    "specificDate": "Dáta sonrach",
    "startDate": "Dáta tosaigh",
    "to": "go dtí"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Eochair Europeana API",
      "noRequests": "Níor úsáideadh aon iarratas chuig Europeana APIs ar an leathanach seo.",
      "settingsPageLinkText": "leathanach socruithe",
      "tip": "Leid: má tá {apiKeyLink} agat cheana féin, is féidir leat é a chur isteach ar an {settingsPageLink} agus beidh sé san áireamh sna naisc iarratais API seo.",
      "title": "Iarratais API"
    },
    "debug": "Díbhug",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Cuir isteach d’eochair API Europeana agus úsáidfear í sna naisc chuig iarratais API.",
          "label": "Eochair API"
        },
        "enabled": {
          "description": "Má tá sé cumasaithe, taispeánfar an roghchlár dífhabhtaithe i mbuntásc an leathanaigh.",
          "label": "Cumasaigh roghchlár debug"
        }
      },
      "title": "Socruithe"
    }
  },
  "delete": "Scrios",
  "depiction": "Léiriú ar {title}",
  "directions": {
    "left": "Ar chlé",
    "right": "Ar dheis"
  },
  "edmIsShownAtLinkAlt": "Amharc air ag láithreán gréasáin an tsoláthraí",
  "entity": {
    "actions": {
      "cancel": "Cealaigh",
      "pin": "Pin mír",
      "unpin": "Mír unpin",
      "viewPinned": "Féach míreanna pinned"
    },
    "labels": {
      "entity": "Eintiteas"
    },
    "notifications": {
      "deleted": "Scriosadh do ghailearaí.",
      "error": {
        "unpin": "Tharla earráid agus an mhír á díphionnáil. Bain triail eile as, nó cuir in iúl don fhadhb."
      },
      "pin": "Taispeánfar an mhír seo ag barr an bhailiúcháin \" {entity} \". Cuirfimid in iúl duit nuair a bheidh an t-athrú seo le feiceáil ar leathanach an bhailiúcháin.",
      "pinLimit": {
        "body": "Go dtí seo ní féidir leat ach 24 earra a phionáil ar an gcéad leathanach. Más mian leat an t-earra seo a phionáil, déan cinnte go ndéanann tú ceann eile a dhíshuiteáil agus ansin déan iarracht an ceann seo a phionáil arís.",
        "title": "An iomarca míreanna pinned"
      },
      "pinned": "Tá an t-earra pinned. Tá sé anois ag barr an chéad leathanaigh den bhailiúchán seo. Thógfadh sé suas le 24 uair an chloig láithriú do gach duine.",
      "select": "Roghnaigh aonán gaolmhar chun an mhír a phionnadh/díphionnáil chuige/ó.",
      "unpin": "Ní thaispeánfar an mhír seo ag barr an bhailiúcháin \" {entity} \". Cuirfimid in iúl duit nuair a bheidh an t-athrú seo le feiceáil ar leathanach an bhailiúcháin.",
      "unpinned": "Tá an mhír díphionnáilte. Níl sé ag barr an chéad leathanaigh den bhailiúchán seo a thuilleadh. D'fhéadfadh sé suas le 24 uair an chloig a thógáil chun imeacht do gach duine."
    }
  },
  "error": "Earráid",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Ní féidir é seo a dhéanamh mar níl gailearaithe príobháideacha le feiceáil ach ag a gcruthóir. Má tá aithne agat ar chruthaitheoir an ghailearaí, iarr orthu an gailearaí a phoibliú. Nó, tuairiscigh an cheist seo agus an cnaipe aiseolais á úsáid agat.",
      "metaTitle": "Gailearaí neamhúdaraithe",
      "title": "Úps! {newline} Tá tú ag iarraidh féachaint ar ghailearaí príobháideach duine eile."
    },
    "itemNotFound": {
      "description": "D'fhéadfadh sé seo a bheith mar gheall ar na cúiseanna seo a leanas: níl an mhír seo ann, nó; dífhoilsíodh é toisc nach raibh sé ag teacht lenár gcritéir cháilíochta, nó; Rinneadh é a nuashonrú agus a athfhoilsiú le haitheantóir uathúil nua, agus sa chás sin, déan iarracht an mhír a aimsiú arís.",
      "metaTitle": "Ní bhfuarthas an mhír",
      "title": "Ó níl! {newline} Ní rabhamar in ann an mhír seo a aimsiú."
    }
  },
  "exhibitions": {
    "chapters": "Caibidlí",
    "credits": "Creidiúintí",
    "currentChapter": "Caibidil reatha",
    "description": "Déan iniúchadh ar na taispeántais",
    "exhibitions": "Taispeántas | Taispeántais"
  },
  "explore": "Déan iniúchadh",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "dathanna",
      "name": "Dath | Dathanna",
      "options": {
        "#000000": "Dubh",
        "#000080": "Dúghorm",
        "#00008B": "Dúghorm",
        "#0000CD": "Gorm Meánach",
        "#0000FF": "Gorm",
        "#006400": "Glas dorcha",
        "#008000": "Faiche Gréasáin",
        "#008080": "Teal",
        "#008B8B": "Cian dorcha",
        "#00BFFF": "Deep Sky Blue",
        "#00CED1": "Turquoise Dorcha",
        "#00FA9A": "Faiche Meánach an Earraigh",
        "#00FF00": "Glas",
        "#00FF7F": "Faiche an Earraigh",
        "#00FFFF": "Cian",
        "#191970": "Gorm Meán Oíche",
        "#1E90FF": "Gorm Seachantóra",
        "#20B2AA": "Faiche na Mara Éadrom",
        "#228B22": "Faiche na Foraoise",
        "#2E8B57": "Faiche na Mara",
        "#2F4F4F": "Liath Slate Dorcha",
        "#32CD32": "Faiche Aoil",
        "#3CB371": "Faiche Meán Mara",
        "#40E0D0": "Turquoise",
        "#4169E1": "Gorm Ríoga",
        "#4682B4": "Cruach Gorm",
        "#483D8B": "Slate Dorcha Gorm",
        "#48D1CC": "Turquoise Meánach",
        "#4B0082": "Indigo",
        "#556B2F": "Faiche Olóige Dorcha",
        "#5F9EA0": "Dalta Gorm",
        "#6495ED": "Bláth an choirn",
        "#663399": "Corcra Rebecca",
        "#66CDAA": "Aquamarine Meánach",
        "#696969": "Dim Grey",
        "#6A5ACD": "Slate Gorm",
        "#6B8E23": "Ológ Leamh",
        "#708090": "Slate Grey",
        "#778899": "Slate Solas Liath",
        "#7B68EE": "Gorm Slate Meán",
        "#7CFC00": "Faiche Faiche",
        "#7F0000": "Marún Gréasáin",
        "#7F007F": "Corcra Gréasáin",
        "#7FFF00": "Chartreuse",
        "#7FFFD4": "Aquamarine",
        "#800000": "Marúin",
        "#800080": "Corcra",
        "#808000": "Olive",
        "#808080": "Grey Gréasáin",
        "#87CEEB": "Gorm na spéire",
        "#87CEFA": "Sky Sky Gorm",
        "#8A2BE2": "Violet Gorm",
        "#8B0000": "Dearg dorcha",
        "#8B008B": "Magenta Dorcha",
        "#8B4513": "Donn Diallait",
        "#8FBC8F": "Faiche na Mara Dorcha",
        "#90EE90": "Solas glas",
        "#9370DB": "Corcra Meánach",
        "#9400D3": "Corcairghorm Dorcha",
        "#98FB98": "Faiche Pale",
        "#9932CC": "Magairlín Dorcha",
        "#9ACD32": "Glas Buí",
        "#A020F0": "Corcra",
        "#A0522D": "Siaineach",
        "#A52A2A": "Donn",
        "#A9A9A9": "Liath Dorcha",
        "#ADD8E6": "Gorm Éadrom",
        "#ADFF2F": "Buí Glas",
        "#AFEEEE": "Turquoise Pale",
        "#B03060": "Marúin",
        "#B0C4DE": "Glasghorm Éadrom",
        "#B0E0E6": "Púdar Gorm",
        "#B22222": "Bríce Dóiteáin",
        "#B8860B": "Slat Óir Dorcha",
        "#BA55D3": "Meán-Mhagairlín",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Khaki dorcha",
        "#BEBEBE": "Liath",
        "#C0C0C0": "Airgid",
        "#C71585": "Meán-Chorcairghorm Dearg",
        "#CD5C5C": "Dearg Indiach",
        "#CD853F": "Peiriú",
        "#D2691E": "Seacláid",
        "#D2B48C": "Tan",
        "#D3D3D3": "Bánliath",
        "#D8BFD8": "Thistle",
        "#DA70D6": "Magairlín",
        "#DAA520": "Goldenrod",
        "#DB7093": "Pale Violet Dearg",
        "#DC143C": "corcairdhearg",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Pluma",
        "#DEB887": "Burlywood",
        "#E0FFFF": "Cian Éadrom",
        "#E6E6FA": "Lavender",
        "#E9967A": "Bradán Dorcha",
        "#EE82EE": "Violet",
        "#EEE8AA": "Pale Goldenrod",
        "#F08080": "Coiréil Éadrom",
        "#F0E68C": "Khaki",
        "#F0F8FF": "Gorm Eilíse",
        "#F0FFF0": "Honeydew",
        "#F0FFFF": "Azure",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Cruithneacht",
        "#F5F5DC": "Beige",
        "#F5F5F5": "Deatach Bán",
        "#F5FFFA": "Uachtar Miontas",
        "#F8F8FF": "Ghost Bán",
        "#FA8072": "Bradán",
        "#FAEBD7": "Antique White",
        "#FAF0E6": "Línéadaigh",
        "#FAFAD2": "Goldenrod Éadrom",
        "#FDF5E6": "Sean-Lása",
        "#FF0000": "Dearg",
        "#FF00FF": "Fuchsia",
        "#FF1493": "Bándearg Domhain",
        "#FF4500": "Oráiste Dearg",
        "#FF6347": "Trátaí",
        "#FF69B4": "Bándearg Te",
        "#FF7F50": "Coiréil",
        "#FF8C00": "Oráiste Dorcha",
        "#FFA07A": "Dath Éadrom an Bhradáin",
        "#FFA500": "Oráiste",
        "#FFB6C1": "Bándearg Éadrom",
        "#FFC0CB": "Bándearg",
        "#FFD700": "Óir",
        "#FFDAB9": "Cúimhín Péitseoige",
        "#FFDEAD": "Bán Navachóis",
        "#FFE4B5": "Mocaisín",
        "#FFE4C4": "Bísc",
        "#FFE4E1": "Rós Ceo",
        "#FFEBCD": "Almond Blanched",
        "#FFEFD5": "Aoire Papaya",
        "#FFF0F5": "Blush lavender",
        "#FFF5EE": "Seashell",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Lemon Chiffon",
        "#FFFAF0": "Bán Floral",
        "#FFFAFA": "Sneachta",
        "#FFFF00": "Buí",
        "#FFFFE0": "Buí Éadrom",
        "#FFFFF0": "Eabhair",
        "#FFFFFF": "Bán"
      },
      "select": "Roghnaigh dathanna"
    },
    "COUNTRY": {
      "name": "Tír sholáthair",
      "options": {
        "Albania": "An Albáin",
        "Austria": "An Ostair",
        "Belarus": "An Bhealarúis",
        "Belgium": "An Bheilg",
        "Bosnia and Herzegovina": "An Bhoisnia agus an Heirseagaivéin",
        "Bulgaria": "An Bhulgáir",
        "Croatia": "An Chróit",
        "Cyprus": "An Chipir",
        "Czech Republic": "Poblacht na Seice",
        "Denmark": "An Danmhairg",
        "Estonia": "An Eastóin",
        "Europe": "An Eoraip",
        "Finland": "An Fhionlann",
        "France": "An Fhrainc",
        "Georgia": "An tSeoirsia",
        "Germany": "An Ghearmáin",
        "Greece": "An Ghréig",
        "Holy See (Vatican City State)": "An Suí Naofa (Stát Chathair na Vatacáine)",
        "Hungary": "An Ungáir",
        "Iceland": "An Íoslainn",
        "Ireland": "Éire",
        "Israel": "Iosrael",
        "Italy": "An Iodáil",
        "Latvia": "An Laitvia",
        "Lithuania": "An Liotuáin",
        "Luxembourg": "Lucsamburg",
        "Macedonia": "An Mhacadóin",
        "Malta": "Málta",
        "Moldova": "An Mholdóiv",
        "Montenegro": "Montainéagró",
        "Netherlands": "An Ísiltír",
        "Norway": "An Iorua",
        "Poland": "An Pholainn",
        "Portugal": "An Phortaingéil",
        "Romania": "An Rómáin",
        "Russia": "An Rúis",
        "Serbia": "An tSeirbia",
        "Slovakia": "An tSlóvaic",
        "Slovenia": "An tSlóvéin",
        "Spain": "An Spáinn",
        "Sweden": "An tSualainn",
        "Switzerland": "An Eilvéis",
        "Turkey": "An Tuirc",
        "Ukraine": "An Úcráin",
        "United Kingdom": "An Ríocht Aontaithe",
        "United States of America": "Stáit Aontaithe Mhéiriceá"
      },
      "select": "Roghnaigh tíortha soláthair"
    },
    "CREATOR": {
      "moreName": "cruthaitheoirí",
      "name": "Cruthaitheoir | Cruthaitheoirí",
      "select": "Roghnaigh cruthaitheoirí"
    },
    "DATA_PROVIDER": {
      "moreName": "institiúidí",
      "name": "Institiúid | Institiúidí",
      "select": "Roghnaigh institiúidí"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Treoshuíomh na híomhá | Treoshuímh na n-íomhánna",
      "options": {
        "landscape": "Tírdhreach",
        "portrait": "Portráid"
      },
      "select": "Roghnaigh treoshuíomhanna íomhá"
    },
    "IMAGE_SIZE": {
      "name": "Méid íomhá | Méideanna íomhá",
      "options": {
        "extra_large": "Rímhór 4MP+ (m.sh. 2688 x 1520px)",
        "large": "Mór 1-4MP (m.sh. 1920x1080px)",
        "medium": "Meán 0.5-1MP (m.sh. 850x850px)",
        "small": "Beag <0.5MP (m.sh. 650x600px)"
      },
      "select": "Roghnaigh méideanna íomhá"
    },
    "LANGUAGE": {
      "name": "Teanga | Teangacha",
      "options": {
        "ar": "Araibis",
        "bg": "Bulgáiris",
        "bs": "Boisnis",
        "ca": "Catalóinis",
        "cs": "Seicis",
        "cy": "Breatnais",
        "da": "Danmhairgis",
        "de": "Gearmáinis",
        "el": "Gréigis",
        "en": "Béarla",
        "es": "Spáinnis ",
        "et": "Eastóinis",
        "fi": "Fionlainnis",
        "fr": "Fraincis",
        "ga": "Gaeilge",
        "gd": "Gaeilge",
        "he": "Eabhrais",
        "hr": "Cróitis",
        "hu": "Ungáiris",
        "is": "Íoslainnis",
        "it": "Iodálach ",
        "lt": "Liotuáinis",
        "lv": "Laitvis",
        "mk": "Macadóinis",
        "mt": "Máltais",
        "mul": "Teangacha éagsúla",
        "nl": "Ísiltíris",
        "no": "Ioruais",
        "pl": "Polainnis",
        "pt": "Portaingéilis ",
        "ro": "Rómáinis",
        "ru": "Rúisis",
        "sk": "Slóvaicis",
        "sl": "Slóivéinis",
        "sq": "Albáinis",
        "sr": "Seirbis",
        "sv": "Sualainnis",
        "tr": "Tuircis",
        "uk": "Úcráinis"
      },
      "select": "Roghnaigh teangacha"
    },
    "MIME_TYPE": {
      "name": "Formáid chomhaid | Formáidí comhaid",
      "options": {
        "text/plain": "Téacs simplí"
      },
      "select": "Roghnaigh formáidí comhaid"
    },
    "PROVIDER": {
      "moreName": "comhbhailitheoirí",
      "name": "Comhbhailitheoir | Comhbhailitheoirí",
      "select": "Roghnaigh comhbhailitheoirí"
    },
    "REUSABILITY": {
      "name": "An féidir liom é seo a úsáid?",
      "options": {
        "open": "Is féidir",
        "permission": "B’fhéidir, iarraidh ar chead a fháil",
        "restricted": "Is féidir, ach amháin faoi réir coinníollacha áirithe",
        "uncategorized": "Gan catagóir"
      },
      "select": "Roghnaigh cé acu an féidir leat é seo a úsáid"
    },
    "TYPE": {
      "name": "Cineál meán",
      "options": {
        "3D": "3T",
        "IMAGE": "Íomha",
        "SOUND": "Fuaim",
        "TEXT": "Téacs",
        "VIDEO": "Físeán"
      },
      "select": "Roghnaigh cineálacha meán"
    },
    "api": {
      "name": "Cuardaigh",
      "options": {
        "fulltext": "Míreanna a bhfuil an téacs iomlán díobh le fáil",
        "metadata": "Míreanna nach bhfuil iontu ach na meiteashonraí amháin"
      },
      "switch": "Ná cuardaigh ach in ábhar na n-ítimí a bhfuil téacs iomlán acu",
      "switchMoreInfo": "Sa bhailiúchán seo, is féidir leat an méid is mian leat a chuardach a roghnú: má tá an lasc seo ar siúl, ansin déanfaidh tú cuardach laistigh den nuachtán agus téacs doiciméid; má tá sé as, ansin déanfaidh tú cuardach laistigh den fhaisnéis a chuireann síos ar an mír, díreach mar a dhéanann tú i gcónaí i bhformhór na mbailiúchán eile."
    },
    "button": {
      "apply": "Cuir i bhfeidhm",
      "cancel": "Cealaigh",
      "morefilters": "Níos mó scagairí",
      "reset": "Athshocraigh",
      "showAll": "Taispeáin gach ceann {label}",
      "showLess": "Taispeáin níos lú {label}"
    },
    "collection": {
      "name": "Téama",
      "options": {
        "archaeology": "Seandálaíocht",
        "art": "Ealaín",
        "fashion": "Faisean",
        "industrial": "Oidhreacht thionsclaíoch",
        "manuscript": "Lámhscríbhinní",
        "map": "Léarscáileanna agus Tíreolaíocht",
        "migration": "Imirce",
        "music": "Ceol",
        "nature": "Stair an Dúlra",
        "newspaper": "Nuachtáin",
        "photography": "Grianghrafadóireacht",
        "sport": "Spórt",
        "ww1": "An Chéad Chogadh Domhanda"
      },
      "select": "Roghnaigh téama"
    },
    "contentTier": {
      "name": "Cáilíocht na míre",
      "options": {
        "*": "Áirítear leis míreanna nach gcomhlíonann ár riachtanais foilsitheoireachta",
        "0": "Ná taispeáin ach míreanna nach gcomhlíonann ár gcritéir foilsitheoireachta",
        "1": "Caighdeán íseal",
        "2": "Caighdeán meánach",
        "3": "Ardchaighdeán & in-athúsáidte le coinníollacha",
        "4": "Ardchaighdeán & in-athúsáidte go saor in aisce"
      },
      "select": "Roghnaigh cáilíochtaí mír"
    },
    "moreOptions": "Cuardaigh chun {0} níos mó {1} a aimsiú.",
    "proxy_dc_format": {
      "name": "Formáid | Formáidí",
      "select": "Roghnaigh formáidí"
    },
    "proxy_dc_type": {
      "name": "Cineál | Cineálacha",
      "select": "Roghnaigh cineálacha"
    },
    "proxy_dcterms_issued": {
      "name": "Dáta eisithe"
    },
    "proxy_dcterms_medium": {
      "name": "Meán | Meáin",
      "select": "Roghnaigh meáin"
    }
  },
  "feedback": {
    "emailOptional": "B’fhéidir gur mhaith linn obair leantach a dhéanamh. Cuir isteach do r-phost má tá tú sásta go ndéanfaimis teagmháil leat.",
    "failed": "Theip ar an iarraidh. Arís, le do thoil.",
    "form": {
      "placeholders": {
        "email": "Cuir isteach do sheoladh ríomhphoist",
        "feedback": "Cuir isteach d'aiseolas anseo"
      }
    },
    "policies": "Trí leanúint ar aghaidh, aontaíonn tú lenár {0} agus aithníonn tú ár {1} .",
    "privacyPolicy": "Beartas Príobháideachais",
    "success": "Tá d'aiseolas seolta.",
    "termsOfService": "Tearmaí Seirbhís",
    "thankYou": "Go raibh maith agat!",
    "title": "Seol Aiseolas",
    "validEmail": "Iontráil seoladh bailí ríomhphoist",
    "validFeedback": "Caithfidh 5 fhocal ar a laghad a bheith i d’aiseolas"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Rannchuiditheoirí",
      "dcCoverage": "Láthair-Am",
      "dcCreator": "Cruthaitheoir",
      "dcDate": "Dáta",
      "dcDescription": "Tuairisc",
      "dcDuration": "Fad",
      "dcFormat": "Formáid",
      "dcIdentifier": "Aitheantóir",
      "dcLanguage": "Teanga",
      "dcPublisher": "Foilsitheoir",
      "dcRelation": "Caidrimh",
      "dcRights": "Cearta",
      "dcSource": "Foinse",
      "dcSubject": "Ábhar",
      "dcTitle": "Teideal",
      "dcType": "Cineál oibiachta",
      "dctermsCreated": "Dáta cruthaithe",
      "dctermsExtent": "Meid",
      "dctermsHasPart": "Lena gcuimsítear",
      "dctermsHasVersion": "Tá leagan aige",
      "dctermsIsFormatOf": "Is formáid de",
      "dctermsIsPartOf": "Is cuid de",
      "dctermsIsReferencedBy": "Tagraítear dó",
      "dctermsIsReplacedBy": "Tagann in ionad",
      "dctermsIsRequiredBy": "Ní foláir dó nó di",
      "dctermsIssued": "Dáta eisiúna",
      "dctermsMedium": "Meánach",
      "dctermsProvenance": "Bunadh",
      "dctermsReferences": "Tagairtí",
      "dctermsSpatial": "Áiteanna",
      "dctermsTOC": "Clár ábhair",
      "dctermsTemporal": "Ama",
      "edmCountry": "Tír sholáthair",
      "edmCurrentLocation": "Suíomh reatha",
      "edmDataProvider": "Institiúid sholáthair",
      "edmHasMet": "Shásaigh",
      "edmIncorporates": "Ionchorpraítear leis",
      "edmIntermediateProvider": "Soláthraí idirmheánach",
      "edmIsDerivativeOf": "Is díorthach é de",
      "edmIsRelatedTo": "Tá baint aige le",
      "edmIsRepresentationOf": "Is léiriú é de",
      "edmIsSimilarTo": "Is cosúil leis",
      "edmIsSuccessorOf": "Is comharba é ar",
      "edmProvider": "Soláthraí",
      "edmRealizes": "Tuigeann sé/sí",
      "edmRights": "Ráiteas Ceadúnas do na meáin sa mhír seo (mura sonraítear a mhalairt)",
      "edmUgc": "Inneachar ginte le húsáideoirí",
      "europeanaCollectionName": "Ainm bailiúcháin",
      "keywords": "Eochairfhocail (a fuarthas iad ó dhaoine den phobal)",
      "timestampCreated": "Stampa ama cruthaithe",
      "timestampUpdate": "Stampa ama nuashonraithe",
      "wasPresentAt": "Bhí i láthair ag",
      "year": "Bliain"
    },
    "webResource": {
      "about": "Maidir le RDF",
      "dcDescription": "Tuairisc",
      "ebucoreHasMimeType": "Cineál MIME Ebucore",
      "edmRights": "Ráiteas ceadúnas don acmhainn meán seo",
      "rdfAbout": "Maidir le RDF"
    }
  },
  "filter": "Scag",
  "filterResults": "Scag torthaí",
  "footer": {
    "customiseWebsiteLanguage": "Saincheap teanga an láithreáin ghréasáin",
    "disclaimerLine1": "Is tionscnamh de chuid an Aontais Eorpaigh é Europeana, arna mhaoiniú ag Saoráid Nascadh na hEorpa agus Ballstáit an Aontais Eorpaigh. Is iad cuibhreannas faoi stiúir Fhondúireacht Europeana a oibríonn seirbhísí Europeana, an láithreán gréasáin seo san áireamh, faoi chonradh seirbhíse leis an gCoimisiún Eorpach.",
    "disclaimerLine2": "Ní ráthaíonn an Coimisiún Eorpach cruinneas na faisnéise agus ní ghlacann sé aon fhreagracht ná dliteanas ar bith maidir leis an bhfaisnéis ar an suíomh Gréasáin seo. Níl an Coimisiún Eorpach, ná aon duine atá ag gníomhú thar ceann an Choimisiúin Eorpaigh, freagrach ná faoi dhliteanas as cruinneas nó úsáid na faisnéise ar an suíomh Gréasáin seo.",
    "findUsElsewhere": "Aimsigh muid áit eile",
    "imageDescription": "Maoinithe ag an Aontas Eorpach",
    "navigation": {
      "MoreInfoLabel": "Tuilleadh eolais",
      "about": "Maidir linne",
      "accessibility": "Inrochtaineacht",
      "cookies": "Fianáin",
      "forDevelopers": "Faoi chomhair forbróirí",
      "help": "Cabhair",
      "privacy": "Beartas Príobháideachais",
      "provide": "Bí I do sholátharí sonraí",
      "subscribe": "Liostáil lenár Nuachtlitir",
      "terms": "Tearmaí Seirbhís"
    },
    "ourMission": "Ár misean",
    "ourMissionQuote": "Tugann Europeana cumhacht don earnáil oidhreachta cultúrtha tabhairt faoin gclaochlú digiteach. Forbraímid saineolas, uirlisí agus beartais chun glacadh leis an athrú digiteach agus spreagaimid comhpháirtíochtaí a chothaíonn an nuálaíocht."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Déan iniúchadh ar ár ngailearaithe",
    "galleries": "Gailearaí | Gailearaithe"
  },
  "goToRecord": "Téigh go dtí an mhír",
  "header": {
    "backToMenu": "Dún Bosca Cuardaigh",
    "clearQuery": "Glan Ceist Cuardaigh",
    "closeSidebar": "Dún Roghchlár",
    "entireCollection": "Cuardaigh {query} inár mbailiúchán iomlán",
    "europeanaHome": "Baile Europeana",
    "inCollection": "Cuardaigh {query} i {collection}",
    "navigation": {
      "about": "Maidir linne",
      "collections": "Bailiúcháin",
      "europeanaClassroom": "Do mhúinteoirí",
      "help": "Cabhair",
      "home": "Baile",
      "pro": "Do ghairmithe",
      "stories": "Scéalta"
    },
    "quickSearch": "Cuardach Tapa",
    "searchFor": "Cuardaigh {query}",
    "searchForEverything": "Cuardaigh gach rud",
    "searchForEverythingInCollection": "Cuardaigh gach rud i {collection}",
    "searchForEverythingInEntireCollection": "Cuardaigh gach rud inár mbailiúchán iomlán",
    "searchForm": "Foirm chuardaigh",
    "showSidebar": "Taispeáin Roghchlár",
    "sideNavigation": "Nascleanúint taobh"
  },
  "homeLinkAlt": "Baile Europeana",
  "homePage": {
    "discoverEditorial": "Na scéalta is déanaí",
    "storiesCTA": "Féach gach scéal",
    "subHeadline": "Cuardaigh, sábháil agus roinn ealaín, leabhair, scannáin agus ceol ó na mílte institiúid chultúrtha",
    "themesCTA": "Féach ar na téamaí go léir",
    "themesTitle": "Déan iniúchadh de réir téama",
    "title": "Faigh amach faoi oidhreacht chultúrtha {digital} na hEorpa",
    "titleDigital": "dhigiteach"
  },
  "imageSlider": {
    "handle": "Hanla Sleamhnáin"
  },
  "items": {
    "itemCount": "1 mír |{count} míreanna",
    "itemOf": "{max} de mhíreanna {count}",
    "recent": "Míreanna le déanaí",
    "recommended": "Míreanna molta",
    "youMightLike": "Míreanna a d’fhéadfadh a bheith uait"
  },
  "klaro": {
    "main": {
      "acceptAll": "Glac le gach",
      "acceptSelected": "Glac leis roghnaithe",
      "consentModal": {
        "description": "Glacaimid go dáiríre le do phríobháideacht sonraí. Anseo is féidir leat na seirbhísí ar mhaith linn a úsáid ar an suíomh Gréasáin seo a mheas agus a shaincheapadh. Tá tú i gceannas! Seirbhísí a chumasú nó a dhíchumasú mar is cuí leat.",
        "title": "Seirbhísí ba mhaith linn a úsáid."
      },
      "consentNotice": {
        "description": "Tugaimid aire do do phríobháideacht agus ní úsáidimid ach sonraí chun d'eispéireas a fheabhsú. Ní úsáidimid aon fhaisnéis phearsanta le haghaidh fógraíochta. Is féidir leat do thoiliú a athrú gach 15 lá.",
        "learnMore": "Lig dom a roghnú"
      },
      "decline": "Meath mé",
      "ok": "ceart go leor",
      "purposes": {
        "essential": {
          "description": "Tá na seirbhísí seo riachtanach chun go bhfeidhmeoidh an láithreán gréasáin seo i gceart. Cuimsíonn siad dearcadh torthaí cuardaigh agus roghanna teanga, caomhnaíonn siad an stát atá logáilte isteach agus coimeád do chuairt slán. Ní féidir leat iad a dhíchumasú mar ní oibreodh an suíomh Gréasáin i gceart a mhalairt.",
          "title": "Seirbhísí riachtanacha maidir le slándáil agus saincheaptha"
        },
        "usage": {
          "description": "Bailíonn na seirbhísí seo an fhaisnéis chun cabhrú linn tuiscint níos fearr a fháil ar an gcaoi a n-úsáidtear an suíomh Gréasáin agus cá bhfuil na pointí pian, ag cur ar ár gcumas roghanna eolasacha a dhéanamh chun d’eispéireas a fheabhsú.",
          "title": "Seirbhísí chun úsáid agus aiseolas láithreán gréasáin a ghabháil"
        }
      },
      "service": {
        "disableAll": {
          "description": "Úsáid an lasc seo chun gach seirbhís roghnach a chumasú nó a dhíchumasú.",
          "title": "Gach seirbhís a chumasú nó a dhíchumasú"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Cuidíonn sé lenár suíomh Gréasáin a fheabhsú trí athruithe turgnamhacha a chur i bhfeidhm ó am go chéile.",
        "title": "Tástáil A/B"
      },
      "auth-strategy": {
        "description": "Is cuimhin leis an straitéis údaraithe a úsáid chun logáil isteach.",
        "title": "Straitéis Auth"
      },
      "debugSettings": {
        "description": "Cuidíonn sé le hiarratais API a dhífhabhtú",
        "title": "Scoránaigh dífhabhtaithe"
      },
      "hotjar": {
        "description": "Gníomhachtaíonn sé giuirléid suirbhé a thugann an rogha duit freagra a thabhairt ar ár suirbhéanna ar shástacht na gcuairteoirí.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Is cuimhin leat an teanga comhéadain is fearr leat le haghaidh rochtana sa todhchaí.",
        "title": "Cód teanga"
      },
      "jira-servicedesk": {
        "description": "Gníomhaíonn sé an giuirléid aiseolais ag tabhairt an rogha duit teagmháil a dhéanamh linn.",
        "title": "Deasc seirbhíse Jira"
      },
      "matomo": {
        "description": "Bailíonn sé staitisticí gan ainm ar an gcaoi a n-idirghníomhaíonn cuairteoirí leis an suíomh Gréasáin.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Taispeánann sé fógra nuair a bhíonn gnéithe nua ar fáil.",
        "title": "Fógra gné nua"
      },
      "searchResultsView": {
        "description": "Cuimhníonn sé más fearr leat na torthaí cuardaigh a fheiceáil i liosta nó in amharc greille.",
        "title": "Amharc toraidh cuardaigh (liosta/greille)"
      }
    }
  },
  "layout": {
    "skipToMain": "Scipeáil chuig inneachar leathanaigh"
  },
  "learnMore": "Faigh amach faoi fhoinse an tuairisc seo",
  "loading": "Ag luchtú",
  "loadingResults": "Torthaí á lódáil",
  "messages": {
    "copyToClipboardSuccess": "Cóipeáilte ar ghearrthaisce",
    "externalContentError": "Theip ar lódáil an inneachair sheachtraigh",
    "notFound": "Níor aimsíodh é",
    "paginationLimitExceeded": "Ní féidir ach amháin na chéad {limit} torthaí cuardaigh a fheiceáil."
  },
  "modal": {
    "download": {
      "clickToCopy": "Cliceáil ar an sannadh chun é a chóipeáil",
      "modalIntro": "Má úsáideann tú an t-earra seo ar an ngréasán nó in áit eile, ná déan dearmad an sannadh seo a leanas a thaispeáint in aice leis:",
      "modalTitle": "Abair go raibh maith agat"
    }
  },
  "multilingual": {
    "automated": "Aistriúchán uathoibrithe",
    "enrichment": "Saibhriú ag tionscadail chomhpháirtíochta",
    "other": "Teangacha eile",
    "stopTranslating": "Stop an t-earra seo a aistriú go {0}.",
    "translateLanguage": "Ar mhaith leat an mhír seo a fheiceáil i {0} ?",
    "translateQuotaError": "Níl an tseirbhís aistriúcháin ar fáil go sealadach. Bain triail eile as níos déanaí."
  },
  "newFeatureNotification": {
    "dismiss": "Dún",
    "readMore": "Léigh níos mó",
    "text": {
      "searchFilters": "Is féidir leat luachanna a chuardach anois sna scagairí aonair; seiceáil amach é!"
    }
  },
  "newWindow": "osclaítear i bhfuinneog nua é",
  "noMoreResults": "Níl aon toradh eile ann ar d'iarratas cuardaigh.",
  "noResults": "Níor aimsíodh aon Torthaí",
  "of": "De",
  "organisation": {
    "city": "Cathair",
    "country": "Tír",
    "englishName": "Ainm Béarla",
    "nameAcronym": "Acrainm ainm"
  },
  "pageHasLoaded": "luchtaithe",
  "pageNumber": "Uimhir an leathanaigh",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Ainm"
        },
        "title": "Eagraíochtaí"
      },
      "persons": {
        "title": "Daoine"
      },
      "places": {
        "title": "Áiteanna"
      },
      "table": {
        "items": "Míreanna",
        "name": "Ainm"
      },
      "times": {
        "title": "Amanna"
      },
      "topics": {
        "title": "Ábhair"
      }
    }
  },
  "pagination": {
    "label": "Leathanaigh"
  },
  "readMore": "Léigh níos mó",
  "recommendation": {
    "prompts": {
      "accept": "Ordóg suas le cur leis an gailearaí",
      "reject": "Ordóg síos mura dtaitníonn leat é"
    }
  },
  "record": {
    "IIIFViewer": "Amharcóir IIIF",
    "actions": {
      "pin": "PIN an mhír chuig na hEintitis atá ar fáil"
    },
    "allMetaData": "Gach meiteashonraí",
    "copyEmbedLabel": "Leabaigh an cód (Cliceáil chun é a chópáil)",
    "exploreMore": "Déan iniúchadh ar níos mó",
    "extendedInformation": "Faisnéis leathnaithe",
    "goodToKnow": "Maith a fhios",
    "hideAll": "Folaigh gach faisnéis",
    "location": "Suíomh",
    "locationOnMap": "Suíomh ar an léarscáil",
    "mediaPlayer": "Seinnteoir meán",
    "record": "Mír",
    "showAll": "Taispeáin gach faisnéis",
    "similarItems": "Míreanna eile den chineál céanna",
    "status": {
      "unpublished": "[Mír neamhfhoilsithe]"
    },
    "transcription": "Tras-scríobh",
    "transcriptionDisclaimer": "Is é an pobal a chuireann an t-ábhar seo ar fáil, ní ag an institiúid a chuir an mhír seo ar fáil."
  },
  "related": {
    "editorial": {
      "title": "Scéalta b’fhéidir gur mhaith leat"
    }
  },
  "relatedCollections": "Bailiúcháin ghaolmhara",
  "removeFilter": "Bain {filterLabel} scagaire",
  "reset": "Athshocraigh",
  "resourceWikimedia": "Acmhainn ó Wikimedia Commons",
  "results": "Torthaí",
  "resultsFor": "Torthaí le haghaidh {0}",
  "resultsLimitWarning": "Ní thaispeántar torthaí breise óir nach dtaispeántar ach amháin an chéad 1000 toradh is ábhartha. Murar aimsigh tú a raibh uait, déan machnamh do chuardach a leasú.",
  "resultsWithin": "Torthaí laistigh de {0} {1} le haghaidh {2}",
  "search": {
    "boost": {
      "placeholder": "Cuir isteach ceist treisithe réimse"
    },
    "title": "Cuardaigh"
  },
  "searchHasLoaded": "{0} torthaí ar ais",
  "searchPlaceholder": "Cuardaigh 50+ milliún mír",
  "searchResults": "Cuardaigh",
  "searchResultsFor": "{0} - Cuardaigh",
  "searchSuggestions": "Cuardaigh moltaí",
  "searchTier": {
    "button": {
      "hide": "Folaigh na míreanna seo",
      "show": "Taispeáin na míreanna seo"
    },
    "text": {
      "hide": "Táthar ag taispeáint míreanna nach sásaíonn ár gcritéir foilsitheoireachta.",
      "show": "Meaisteálann níos mó míreanna do chuardach ach ní shásaíonn ár gcritéir foilsitheoireachta"
    }
  },
  "searchViews": {
    "grid": "Amharc greille",
    "list": "Amharc liosta",
    "mosaic": "Amharc mósáic"
  },
  "set": {
    "actions": {
      "addTo": "Cuir leis an ngailearaí",
      "create": "Cruthaigh gailearaí",
      "createNew": "Cruthaigh gailearaí nua",
      "delete": "Scrios gailearaí",
      "edit": "Cuir an gailearaí in eagar",
      "update": "Nuashonraigh gailearaí"
    },
    "form": {
      "description": "Tuairisc ar ghailearaí",
      "private": "Coinnigh an gailearaí seo príobháideach",
      "required": "Réimsí riachtanacha",
      "title": "Ainm an ghailearaí"
    },
    "labels": {
      "curatedBy": "Coimeádaithe ag",
      "private": "Gailearaí príobháideach"
    },
    "notifications": {
      "deleted": "Scriosadh do ghailearaí.",
      "likeLimit": {
        "body": "Tá brón orainn, ach tá tú teoranta i láthair na huaire chun uasmhéid 100 earra a thaitin.Bainfimid an teorainn seo go luath!",
        "title": "100 Is maith liom"
      },
      "updated": "Cuireadh an mhír leis an ngailearaí."
    },
    "prompts": {
      "delete": "An bhfuil tú cinnte gur mhaith leat an gailearaí seo a scriosadh? Má scriosann tú an gailearaí seo, caillfidh tú na míreanna go léir a chuir tú leis."
    }
  },
  "showLess": "Taispeáin níos lú",
  "showMore": "Taispeáin níos mó",
  "sideFilters": {
    "noOptions": "Níl aon roghanna ar fáil le roghnú",
    "search": "Cuardaigh"
  },
  "statuses": {
    "liked": "Thaitin sé",
    "pinned": "Pionnáilte"
  },
  "storiesPage": {
    "title": "Scéalta"
  },
  "website": "Suíomh Gréasáin",
  "youMightAlsoLike": "B'fhéidir gur mhaith leat freisin"
};
